import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { LogoComponent, LogoVariant, LogoColor } from '../logo/logo.component';
import type { PsUiSize } from '../../types';
import { LinkComponent } from '../link/link.component';

@Component({
  selector: 'ps-navbar',
  imports: [LogoComponent, LinkComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'banner',
  },
})
export class NavbarComponent {
  public readonly ariaLabel = input<string>('Main navigation');
  public readonly logoSize = input<PsUiSize>('md');
  public readonly logoColor = input<LogoColor>('white');

  public readonly logoVariant = input<LogoVariant>('full');
  public readonly centerLogo = input<boolean>(false);

  protected readonly dataCy = computed(
    () => `ps-navbar-${this.centerLogo() ? 'center-brand' : 'default'}`,
  );
}
